import React from 'react';
import { Icon } from '@brighterion/br-ui';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';

import styles from './Header.css';

interface Props {
    dataTestId: string;
    closeSplitView(): void;
}

const Close = ({ dataTestId, closeSplitView }: Props) => {
    return (
        <Icon
            data-testid={dataTestId}
            tabIndex={0}
            className={styles.closeCls}
            name='close-x'
            size='xlg'
            onClick={handleOnClickEvent(closeSplitView)}
            onKeyDown={handleKeyEvent(closeSplitView)}
        />
    );
};

export default React.memo(Close);
